<template>
  <div>
    <!-- Hero Header -->
    <div
      class="berita-detail-header header-content"
      style="background-image: url();"
      :style="detail.picture_path ? `background-image: url(${detail.picture_path}); background-size: cover; background-position: center;` : ''"
    >
      <div class="berita-header-content">
        <span class="article-label">
          <b-icon icon="newspaper" font-scale="0.8"></b-icon>
          Berita &nbsp;·&nbsp; 5 min baca
        </span>
        <h2>{{ detail.title }}</h2>
        <div class="article-meta">
          <div class="meta-author">
            <img src="@/assets/images/avatar.png" alt="Admin" />
            <span>Admin</span>
          </div>
          <span class="meta-date">{{ detail.publish_date }}</span>
        </div>
      </div>
    </div>

    <!-- Content Area -->
    <div class="container-standar" style="padding-bottom: 80px;">
      <div class="berita-content-card">
        <b-row>
          <!-- Share sidebar -->
          <b-col cols="12" lg="1" md="1" class="berita-share-sidebar">
            <span class="share-label">Bagikan</span>
            <div class="share-icons">
              <ShareNetwork
                v-for="network in networks"
                :network="network.network"
                :key="network.network"
                :url="sharing.url"
                :title="sharing.title"
                :description="sharing.description"
                :quote="sharing.quote"
                :hashtags="sharing.hashtags"
              >
                <b-icon
                  :icon="network.icon"
                  font-scale="1.1"
                ></b-icon>
              </ShareNetwork>
            </div>
          </b-col>

          <!-- Article body -->
          <b-col cols="12" lg="10" md="10">
            <div class="article-text" v-html="detail.content"></div>
          </b-col>

          <b-col cols="12" lg="1" md="1"></b-col>
        </b-row>
      </div>

      <!-- Related News -->
      <div style="margin-top: 64px;">
        <h3 class="related-heading">Berita <span>Terkait</span></h3>
        <div class="news-grid">
          <a
            v-for="(berita, index) in related"
            :key="index"
            :href="'/berita/' + berita.slug"
            class="news-card"
          >
            <div class="news-card-img-wrap">
              <img :src="berita.picture_path" :alt="berita.title" />
              <span class="news-card-category">Berita</span>
            </div>
            <div class="news-card-body">
              <div class="news-card-meta">
                <b-icon icon="calendar3" font-scale="0.75" style="color: var(--text-light);"></b-icon>
                <span class="meta-date">{{ berita.created }}</span>
              </div>
              <h3 class="news-card-title">{{ berita.title | shotDescription(80) }}</h3>
              <p class="news-card-excerpt">{{ berita.content | shotDescription(120) }}</p>
              <div class="news-card-author">
                <img class="author-avatar" src="@/assets/images/avatar.png" alt="Admin" />
                <span class="author-name">Admin</span>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detail: {},
      related: [],
      networks: [
        { network: "facebook", name: "Facebook", icon: "facebook", color: "#1877f2" },
        { network: "linkedin", name: "LinkedIn", icon: "linkedin", color: "#007bb5" },
        { network: "twitter", name: "Twitter", icon: "twitter", color: "#1da1f2" },
      ],
    };
  },
  computed: {
    sharing() {
      return {
        url: "https://siopapua.papua.go.id/berita/" + this.detail.id,
        title: this.detail.title,
        description: "Description",
        quote: "quote",
        hashtags: "hastags",
      };
    },
  },
  async mounted() {
    this.$store.commit("SET_BG", false);
    await this.getDetail(this.$route.params.id);
    this.getBerita();
  },
  methods: {
    async getDetail(id) {
      await this.$axios.get("/news/" + id).then((response) => {
        this.detail = response.data.data;
      });
    },
    getBerita() {
      this.$axios.get("/news").then((response) => {
        this.related = response.data.data.filter((_, index) => index < 3);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
hr.rounded {
  border-top: 2px solid #e2e8f0;
  border-radius: 5px;
}
</style>
